import { DataTable, DataTableResource, DataTableTranslations } from 'angular7-data-table';
import { NgbModalRef, NgbModalOptions, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CdkDragDrop, moveItemInArray, CdkDragExit } from '@angular/cdk/drag-drop';
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { NgxSpinnerService } from "ngx-spinner";
import { CourseManagementService } from "../course-management.service";
import { HttpResponse } from "@angular/common/http";
import Swal from "sweetalert2";


@Component({
  selector: 'app-view-asr',
  templateUrl: './view-asr.component.html',
  styleUrls: ['./view-asr.component.css']
})
export class ViewAsrComponent implements OnInit {


  @ViewChild(TemplateRef, { static: false }) tpl: TemplateRef<any>;

  AsrForm: FormGroup;
  slideForm: FormGroup;
  optionForm: FormGroup;

  formSubmitted: boolean = false;
  showLessonError: boolean = true;
  showWeekError: boolean = true;
  showAdditionalError: boolean = true;
  isDisabled: boolean = true;

  //QUESTION TYPE BOOLEAN
  show_optionsButton: boolean = false;
  show_optionsCheckBox: boolean = false;
  show_optionsSlider: boolean = false;
  show_slider: boolean = false;
  show_text: boolean = false;
  show_days: boolean = false;
  show_textDropdown: boolean = false;
  showOptionError: boolean = true;



  question_type: any;
  selectedFile: any;
  uploadcourseImage: any;
  week: string;
  courseId: string;
  ASRReq = {
    courseId: null,
    week: null,
    observeAudioUrl: null,
    physicalQuestion: [],
    nutritionalQuestion: [],
    introspectQuestion: [],
    nextActionStepQuestion: []
  }
  ASRQuestionType: string;
  optionList: any;
  QuestionFormReq = {
    questionText: null,
    iconName: null,
    type: null,
    options: [],
    daysSuccess: [],
    sliderDetails: {
      minValue: 0,
      maxValue: 0,
      defaultValue: 0,
      multiplyFactor: 0
    },
    sortOrder: null,
    weightage: null,
    evaluationData: ""

  }
  asrDetail: any;

  uploadCourseImage: any;
  QuestionTypeList = [
    { value: 'days', viewValue: 'Days' },
    { value: 'optionsButton', viewValue: 'Option' },
    { value: 'optionsCheckBox', viewValue: 'Check Box' },
    { value: 'optionsSlider', viewValue: 'Options Slider' },
    { value: 'slider', viewValue: 'slider' },
    { value: 'text', viewValue: 'text' },
    { value: 'textDropdown', viewValue: 'Text Drop Down' },
  ];
  BuildingQuestionTypeList = [
    { value: 'days', viewValue: 'Days' },
    { value: 'optionsButton', viewValue: 'Option' },
    { value: 'optionsCheckBox', viewValue: 'Check Box' },
    { value: 'slider', viewValue: 'slider' },
  ];
  ActionStepQuestionTypeList = [
    { value: 'days', viewValue: 'Days' },
    { value: 'optionsButton', viewValue: 'Option' },
    { value: 'optionsCheckBox', viewValue: 'Check Box' },
    { value: 'slider', viewValue: 'slider' },
    { value: 'text', viewValue: 'text' },
    { value: 'textDropdown', viewValue: 'Text Drop Down' },
    { value: 'optionsSlider', viewValue: 'Options Slider' },
    { value: 'multiOptionsCheckBox', viewValue: 'Multi Options CheckBox' },


  ];


  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };

  DaysList = [{ day: "1", value: "0" }, { day: "2", value: "0" }, { day: "3", value: "0" }, { day: "4", value: "0" }, { day: "5", value: "0" }, { day: "6", value: "0" }, { day: "7", value: "0" }]
  closeResult: string;
  statusFormSubmitted: boolean = false;
  statusForm: FormGroup;
  optionListtemp = [];
  finalFeatureList = [];
  temp: any;
  feature: string;
  constructor(private formBuilder: FormBuilder, private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private CourseManagementService: CourseManagementService) { }

  ngOnInit() {
    this.ASRQuestionType = "PHYSICAL";
    this.courseId = this.route.snapshot.params["course_Id"];
    this.route.queryParams.subscribe(param => {
      this.week = param['week'];
    });

    this.initialiseForms();
    this.getEsrDetails(this.courseId, this.week);

  }

  initialiseForms() {
    this.AsrForm = this.fb.group({
      week: ["", [Validators.required]],
      observeAudioUrl: ["", [Validators.required]],
      questionType: ["", [Validators.required]]
    });


    this.slideForm = this.fb.group({
      minValue: [0, [Validators.required]],
      maxValue: [0, [Validators.required]],
      defaultValue: [0, [Validators.required]],
      multiplyFactor: [0, [Validators.required]]
    });
    this.optionForm = this.fb.group({
      label: ["", [Validators.required]],
      value: ["", [Validators.required]],
      evaluationData: ["", [Validators]],
      sortOrder: ["", [Validators.required]],
      isSelected: ["", [Validators.required]],
      weightage: ["", [Validators.required]],
      iconName: ["noIcon", [Validators.required]],
      questionText: ["", [Validators.required]],
    });

  }

  getEsrDetails(courseId, Week) {
    let query = courseId + "/" + Week;
    this.CourseManagementService.getASRbyCourseWeek(query).subscribe(res => {
      if ((res["message"] = "Success")) {
        this.asrDetail = res.data;
        this.ASRReq.physicalQuestion = this.asrDetail.physicalQuestion;
        this.ASRReq.nutritionalQuestion = this.asrDetail.nutritionalQuestion;
        this.ASRReq.introspectQuestion = this.asrDetail.introspectQuestion;
        this.ASRReq.nextActionStepQuestion = this.asrDetail.nextActionStepQuestion;
        this.updateForm();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });

  }
  updateForm() {

    this.AsrForm.patchValue({
      week: this.asrDetail.week,
      observeAudioUrl: this.asrDetail.observeAudioUrl
    });
    this.AsrForm.controls['week'].disable();
    this.AsrForm.controls['observeAudioUrl'].disable();
  }







  setamount(event, index) {
    this.DaysList[index]['value'] = null;
  }


  onChange(event, index) {

  }
  saveQuestion(type: any) {

    if (type == 'optionsButton' || type == 'optionsCheckBox') {

      this.QuestionFormReq.questionText = this.optionForm.value.questionText;
      this.QuestionFormReq.iconName = this.optionForm.value.iconName;
      this.QuestionFormReq.weightage = this.optionForm.value.weightage;
      this.QuestionFormReq.type = this.question_type;
      let optionListtemp = [];
      this.optionList.forEach((element, index) => {
        optionListtemp.push({ label: element.label, value: element.value, evaluationData: element.evaluationData, sortOrder: index });
        this.QuestionFormReq.options = optionListtemp;
        this.optionListtemp = [];
      });


    }

    if (type == 'days') {
      this.QuestionFormReq.questionText = this.optionForm.value.questionText;
      this.QuestionFormReq.iconName = this.optionForm.value.iconName;
      this.QuestionFormReq.weightage = this.optionForm.value.weightage;
      this.QuestionFormReq.type = this.question_type;
      this.QuestionFormReq.daysSuccess = this.DaysList;

    }
    if (type == 'slider') {

      this.QuestionFormReq.questionText = this.optionForm.value.questionText;
      this.QuestionFormReq.iconName = this.optionForm.value.iconName;
      this.QuestionFormReq.weightage = this.optionForm.value.weightage;
      this.QuestionFormReq.type = this.question_type;
      this.QuestionFormReq.sliderDetails.minValue = this.slideForm.value.minValue;
      this.QuestionFormReq.sliderDetails.maxValue = this.slideForm.value.maxValue;
      this.QuestionFormReq.sliderDetails.defaultValue = this.slideForm.value.defaultValue;
      this.QuestionFormReq.sliderDetails.multiplyFactor = this.slideForm.value.multiplyFactor;

    }
    if (type == 'optionsSlider') {

      this.QuestionFormReq.questionText = this.optionForm.value.questionText;
      this.QuestionFormReq.iconName = this.optionForm.value.iconName;
      this.QuestionFormReq.weightage = this.optionForm.value.weightage;
      this.QuestionFormReq.type = this.question_type;
      // for the option
      let optionListtemp = [];
      this.optionList.forEach((element, index) => {
        optionListtemp.push({ label: element.label, value: element.value, evaluationData: element.evaluationData, sortOrder: index });
        this.QuestionFormReq.options = optionListtemp;
      });
      this.QuestionFormReq.sliderDetails.minValue = this.slideForm.value.minValue;
      this.QuestionFormReq.sliderDetails.maxValue = this.slideForm.value.maxValue;
      this.QuestionFormReq.sliderDetails.defaultValue = this.slideForm.value.defaultValue;
      this.QuestionFormReq.sliderDetails.multiplyFactor = this.slideForm.value.multiplyFactor;

    }

    if (type == 'text') {

      this.QuestionFormReq.questionText = this.optionForm.value.questionText;
      this.QuestionFormReq.iconName = this.optionForm.value.iconName;
      this.QuestionFormReq.weightage = this.optionForm.value.weightage;
      this.QuestionFormReq.type = this.question_type;
      this.QuestionFormReq.evaluationData = this.optionForm.value.evaluationData;

      // for the option


    }
    ////////////////////////////////////////////////////////////////////////////////
    //ASR QUESTION TYPE 
    //////////////////////////////////////////////////////////////////////////




    if (this.ASRQuestionType == 'PHYSICAL') {
      let asrquestionLength = this.ASRReq.physicalQuestion.length;
      if (asrquestionLength == 0) {
        this.QuestionFormReq.sortOrder = 0;
      } else {
        this.QuestionFormReq.sortOrder = asrquestionLength + 1;
      }
      this.QuestionFormReq.iconName = "exercise"
      this.ASRReq.physicalQuestion.push(this.QuestionFormReq);

    }
    if (this.ASRQuestionType == 'NUTRITIONAL') {
      let asrquestionLength = this.ASRReq.nutritionalQuestion.length;
      if (asrquestionLength == 0) {
        this.QuestionFormReq.sortOrder = 0;
      } else {
        this.QuestionFormReq.sortOrder = asrquestionLength + 1;
      }
      this.QuestionFormReq.iconName = "nutrition";
      this.ASRReq.physicalQuestion.push(this.QuestionFormReq);


    }
    if (this.ASRQuestionType == 'INTROSPECT') {
      let asrquestionLength = this.ASRReq.introspectQuestion.length;
      if (asrquestionLength == 0) {
        this.QuestionFormReq.sortOrder = 0;
      } else {
        this.QuestionFormReq.sortOrder = asrquestionLength + 1;
      }
      this.QuestionFormReq.iconName = "introspect";
      this.ASRReq.physicalQuestion.push(this.QuestionFormReq);
    }





  }

  submitASR() {

    this.ASRReq.courseId = this.courseId;
    this.ASRReq.week = this.AsrForm.value.week;
    this.ASRReq.observeAudioUrl = this.AsrForm.value.observeAudioUrl;


    if (this.AsrForm.valid) {
      this.CourseManagementService.saveASR(this.ASRReq).subscribe(data => {
        if (data["message"] == "Success") {
          Swal.fire("Success", "ASR Added successfully!", "success");
          this.router.navigate(['main/course-management/view-lesson/', this.courseId]);

        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });

    }



  }
  questionType(value) {
    this.ASRQuestionType = value;
  }

  AddQuestion() {

    this.question_type = this.AsrForm.value.questionType;
    if (this.AsrForm.value.questionType == "days") {
      this.show_days = true;
      this.show_slider = false;
      this.show_optionsButton = false;
      this.show_text = false;
    }
    if (this.AsrForm.value.questionType == "slider") {
      this.show_days = false;
      this.show_slider = true;
      this.show_optionsButton = false;
      this.show_optionsSlider = false;
      this.show_text = false;
    }
    if (this.AsrForm.value.questionType == "optionsButton" || this.AsrForm.value.questionType == "optionsCheckBox" || this.AsrForm.value.questionType == "textDropdown") {
      this.show_days = false;
      this.show_slider = false;
      this.show_optionsButton = true;
      this.show_optionsSlider = false;
      this.show_text = false;
    }
    if (this.AsrForm.value.questionType == "optionsSlider") {
      this.show_days = false;
      this.show_slider = false;
      this.show_optionsSlider = true;
      this.show_optionsButton = false;
      this.show_text = false;

    }
    if (this.AsrForm.value.questionType == "text") {
      this.show_days = false;
      this.show_slider = false;
      this.show_optionsSlider = false;
      this.show_optionsButton = false;
      this.show_text = true;
    }


  }
  filmCount = 2;
  labels = <DataTableTranslations>{
    loadingText: 'Your {title} table is reloading - and this is my custom message.',
    paginationText: 'Your table displays {from} to {to} of {total} rows.'
  };

  AddOption() {
    this.optionListtemp.push({ label: this.optionForm.value.label, value: this.optionForm.value.value, evaluationData: this.optionForm.value.evaluationData });
    this.optionList = this.optionListtemp;
    if (this.optionList.length > 0) {
      this.showOptionError = false;
      this.optionForm.controls['value'].setValue(" ");
      this.optionForm.controls['evaluationData'].setValue(" ");
      this.optionForm.controls['label'].setValue(" ");
    }

  }

  updateUserStatusModal(row, content, btn) {
    this.AddQuestion();
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    // this.userDetails = row;
    this.statusFormSubmitted = false;
    // this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  cancel() {
    this.router.navigate(['main/course-management/view-lesson/', this.courseId]);
  }

}
